module.exports = __webpack_public_path__ + "static/media/PushtimargImage37.5f7bca06.jpg";